<template>
  <div>
    <vs-table
      stripe
      border
      description
      v-model="itemSelected"
      multiple
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <div class="flex items-center">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangelength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div class="ml-5">
            <vs-button size="medium" color="primary" @click="submit()"
              >Confirm</vs-button
            >
          </div>
        </div>
        <vx-input-group class="ml-4 items-center">
          <vs-input
            v-model="searchQuery"
            placeholder="Search Here"
            @keyup.enter="handleSearch"
          />
          <template slot="append">
            <div class="append-text btn-addon" style="height: 38px">
              <vs-button
                color="primary"
                icon-pack="feather"
                icon="icon-search"
                style="height: 100%"
                @click="handleSearch"
              />
            </div>
          </template>
        </vx-input-group>
      </template>
      <template slot="thead">
        <!-- <vs-th
                    ><vs-checkbox
                      v-model="selectAll"
                      @input="handleSelectAll"
                    />ALL</vs-th
                  > -->

        <vs-th>Select</vs-th>
        <vs-th sort-key="code">Shipment Data</vs-th>
        <vs-th sort-key="name">Driver</vs-th>
        <vs-th sort-key="name">Customer Data</vs-th>
        <!-- <vs-th sort-key="name">SO Data</vs-th> -->
        <vs-th sort-key="name">DO/DN Data</vs-th>
        <!-- <vs-th sort-key="name">List Item</vs-th> -->
        <vs-th sort-key="name">Payment Term</vs-th>
        <vs-th sort-key="name">Source</vs-th>
        <vs-th sort-key="name">POD Status</vs-th>
        <vs-th sort-key="name">Document</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-input-group flex">
              <vs-button
                size="small"
                color="primary"
                icon-pack="feather"
                icon="icon-edit"
                style="margin-right: 5px"
                title="Edit"
                @click="handleEdit(tr)"
              />
            </div>
          </vs-td>

          <vs-td>
            <ol class="bullet-list">
              <li>
                {{ tr.shipment_number }}
              </li>
              <li>
                {{ tr.delivery_date }}
              </li>
            </ol>
          </vs-td>
          <vs-td>
            <ol class="bullet-list">
              <li>
                {{ tr.driver_name }}
              </li>
              <li>
                {{ tr.vehicle_number }}
              </li>
            </ol>
          </vs-td>
          <vs-td>
            <ol class="bullet-list">
              <li>
                {{ tr.customer_code }}
              </li>
              <li>
                {{ tr.customer_name }}
              </li>
              <li>
                {{ tr.zone_name }}
              </li>
            </ol>
          </vs-td>
          <!-- <vs-td>
            <ol>
              <li>
                {{ tr.sales_order_code }}
              </li>
            </ol>
          </vs-td> -->
          <vs-td>
            <ol class="bullet-list">
              <li>{{ tr.delivery_order_code }}</li>
              <li>{{ tr.customer_name }}</li>
            </ol>
          </vs-td>
          <!-- <vs-td>
            <ol v-for="(item, index) in tr.items_pod" :key="index">
              <li>{{ index + 1 }}. {{ item.item_name }}</li>
            </ol>
          </vs-td> -->
          <vs-td>
            {{ tr.payment_term }}
          </vs-td>
          <vs-td>
            {{ tr.notes }}
          </vs-td>
          <vs-td>
            {{ tr.status_delivery ? tr.status_delivery : "" }}
          </vs-td>
          <vs-td>
            <div class="vx-input-group flex">
              <vs-checkbox
                :vs-value="tr"
                color="success"
                disabled
                :checked="tr.is_document"
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},

  mounted() {
    // Only call getDatas if it's the first load and not already loading
    // if (!this.hasInitialLoad && !this.isLoadingData) {
    // this.hasInitialLoad = true;
    // this.getDatas();
    // }
    this.getPermission();
  },
  props: {
    transportPlanID: {
      type: Number,
      default: null,
    },
    warehouseID: {
      type: Number,
      default: null,
    },
    driverName: {
      type: String,
      default: null,
    },
    dateStart: {
      type: String,
      default: "",
    },
    dateEnd: {
      type: String,
      default: "",
    },
    selectedStatus: {
      type: Object,
      default: null,
    },
    isFilters: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      itemSelected: [],
      deleteId: null,
      table: this.tableDefaultState(),
      transportPlan: [],
      exportID: [],
      IDwasGenerate: [],
      showingData: true,
      selectAll: false,
      cartPODConfirm: [],
      cartTransportPlan: [],
      IDItem: [],
      permission: [],
      isLoadingData: false, // Flag to prevent duplicate API calls
      hasInitialLoad: false, // Flag to track initial load
      searchQuery: "",
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch() {
      this.table.search = this.searchQuery;
      this.table.page = 1;
      this.getDatas();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getDatas();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getDatas();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getDatas();
    },

    getDatas() {
      // Prevent duplicate API calls
      // if (this.isLoadingData) {
      //   console.log("getDatas already in progress, skipping...");
      //   return;
      // }

      // this.isLoadingData = true;
      this.table.data = [];
      this.IDItem = [];
      this.itemSelected = [];
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/proof-of-delivery/pod-table", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            transport_plan_id:
              this.$store.getters["pod/pod/getTransportPlanID"],
            warehouse_id: this.$store.getters["pod/pod/getWarehouseID"],
            date_from: moment(this.$store.state.pod.pod.date.startDate).format(
              "YYYY-MM-DD"
            ),
            date_to: moment(this.$store.state.pod.pod.date.endDate).format(
              "YYYY-MM-DD"
            ),
            status: 0,
            driver_name: this.$store.getters["pod/pod/getDriverName"],
            status_delivery: this.selectedStatus
              ? this.selectedStatus.id
              : null,
            notes: "ePOD",
          },
        })
        .then((resp) => {
          console.log("getDatas API response:", resp);
          if (resp.code == 200) {
            if (resp.data.records != null) {
              this.table.data = [];
              this.table.total = resp.data.total_record;
              this.table.totalPage = resp.data.total_page;
              this.table.totalSearch = resp.data.total_record_search;
              this.table.length = resp.data.total_record_per_page;
              this.table.data = resp.data.records;
              for (let index = 0; index < resp.data.records.length; index++) {
                this.table.data[index]["indextr"] = index;
              }

              this.$emit("isFilters", false);
              this.setStartEnd();
            } else {
              this.table.data = [];
              this.table.total = 0;
              this.table.totalPage = 0;
              this.table.totalSearch = 0;
              this.table.length = 0;
              this.table.data = [];
              this.setStartEnd();
            }
          }
        })
        .catch((error) => {
          console.error("Error in getDatas:", error);
        })
        .finally(() => {
          // this.isLoadingData = false;
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }

      if (this.table.total == 0) {
        valStart = 0;
      }

      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (this.totalSearch < this.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleClickCheckBox() {
      console.log(">>>>iiii", this.cartPODConfirm.id);
      this.$emit("selected-items", this.cartPODConfirm);
    },
    submit() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Confirm",
        text: "Are you sure to confirm this data?",
        acceptText: "ok",
        accept: () => {
          this.SubmitForm();
        },
      });
    },
    SubmitForm() {
      console.log(">>>>>ini submit", this.itemSelected);
      if (this.itemSelected.length == 0) {
        this.$vs.notify({
          title: "Error",
          text: "Please select Item Line first",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return true;
      }

      for (let index = 0; index < this.itemSelected.length; index++) {
        let items = {};
        items.id = this.itemSelected[index].pod_id;
        items.status = 2;
        // if (this.itemSelected[index].status_delivery == "Partial Complete") {
        //   this.$vs.notify({
        //     title: "Error",
        //     text: "You Have Data With Partial Complete, Then Confirm on Detail MENU",
        //     color: "danger",
        //     position: "top-right",
        //     iconPack: "feather",
        //     icon: "icon-check",
        //   });
        //   this.itemSelected = [];
        //   this.IDItem = [];
        //   return true;
        // }
        items.isDelivered = this.itemSelected[index].is_delivered;

        this.IDItem.push(items);
      }

      for (let index = 0; index < this.IDItem.length; index++) {
        if (this.IDItem[index].id == 0) {
          this.$vs.notify({
            title: "Error",
            text: "You Have delivery order does't set STATUS POD",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });
          this.itemSelected = [];
          this.IDItem = [];
          return true;
        }
        if (!this.IDItem[index].isDelivered) {
          this.$vs.notify({
            title: "Error",
            text: "You Have Shipments does't finish delivery",
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });
          this.itemSelected = [];
          this.IDItem = [];
          return true;
        }
      }
      this.$vs.loading();
      this.$http
        .post("/api/wms/v1/proof-of-delivery/process", {
          pod_process: this.IDItem,
          is_epod: true,
        })
        .then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.$vs.notify({
              title: "Success",
              text: "Process Success",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.getDatas();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.getDatas();
          }

          this.$vs.loading.close();
        });
    },
    handleEdit(data) {
      console.log("data", data);
      this.$vs.loading();
      this.$router.push({
        name: "Eproof-of-delivery-edit",
        query: {
          id: data.id,
          action: "Edit",
        },
      });
      this.$vs.loading.close();
    },
    getPermission() {
      this.$vs.loading();
      this.$http
        .get("/api/account/v1/permission", {
          params: {
            module: "pod",
            source: "WMS",
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.permission = resp.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        });
    },
  },
  watch: {
    detail() {},
    isFilters(val) {
      // Only call getDatas if not already loading and filter is explicitly requested
      // if (val && !this.isLoadingData) {
      console.log("Filter triggered, calling getDatas...");
      this.getDatas();
      this.$emit("isFilters", false);
      // }
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
    hasPermission() {
      return (guardName) => {
        return this.permission.some((perm) => perm.GuardName === guardName);
      };
    },
  },
  filters: {
    formatDate(val) {
      return moment(val)
        .add(-7, "h")
        .utc()
        .local()
        .format("DD MMM YYYY HH:mm:ss");
    },
  },
};
</script>
<style>
.bullet-list {
  list-style-type: disc; /* Atur tipe tanda (dalam hal ini tanda titik) */
  padding-left: 20px; /* Atur jarak kiri untuk membuat tanda tampak lebih baik */
}
</style>
